// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.persona-content {
    display: flex;
    flex-direction: row;
    gap: 2px;
}

@media screen and (max-width: 640px) {
    .persona-content {
        flex-direction: column;
    }
}`, "",{"version":3,"sources":["webpack://./src/Docs/Components/Persona/examples/Persona.Example.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".persona-content {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 2px;\r\n}\r\n\r\n@media screen and (max-width: 640px) {\r\n    .persona-content {\r\n        flex-direction: column;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
